
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	RequestedDateFrom: null as Date | null,
	RequestedDateTo: null as Date | null,
	Status: null as String | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Status: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			DOWNLOAD_URL: {
				isEditable: false,
				required: false,
			},
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
